<template>
  <div class="c-relative">
    <Breadcrumb class="c-path">
      <BreadcrumbItem>QueryEngine</BreadcrumbItem>
      <BreadcrumbItem v-for="item in bread" :key="item.name">
        <span @click="menuClicked(item)">{{ item.meta.title }}</span>
      </BreadcrumbItem>
    </Breadcrumb>
    <div class="c-regions" style="display: inline-flex">
      <ButtonGroup checkType="radio" v-model="region">
        <Button
          v-for="region in regions"
          :key="region.code"
          :value="region.code"
          size="small"
          >{{ region.name }}</Button
        >
      </ButtonGroup>
    </div>
  </div>
</template>
<script>
import { Breadcrumb, BreadcrumbItem } from 'kpc/components/breadcrumb';
import { Button, ButtonGroup } from 'kpc/components/button';
function getRegion() {
  let regionKey = window.appLocals.regionKey;
  if (!regionKey || ['cn-beijing-6', 'cn-shanghai-2'].indexOf(regionKey) < -1) {
    regionKey = 'cn-beijing-6';
  }
  return window.sessionStorage.getItem('regionKey') || regionKey;
}
function setRegion(region) {
  window.sessionStorage.setItem('regionKey', region);
  window.appLocals.regionKey = region;
}
export default {
  props: {
    bread: {
      type: Array,
      default: function() {
        return [];
      }
    },
    regions: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    menuClicked(item) {
      this.$emit('menu-clicked', item);
    },
    regionClicked(item) {
      this.$emit('region-clicked', item);
    }
  },
  data() {
    return {
      region: ''
    };
  },
  watch: {
    region(n, o) {
      if (n && n !== o) {
        this.$EventBus.$emit('REGION_CHANGED');
        // window.appLocals.regionKey = n;
        setRegion(n);
      }
      console.log(n, o);
    }
  },
  mounted() {
    let region = getRegion();
    this.region = region;

    console.log(region, 111);
    if (!region) {
      setRegion('cn-beijing-6');
      // window.appLocals.regionKey = 'cn-beijing-6';
      return;
    }
    for (let i = 0; i < this.regions.length; i++) {
      let item = this.regions[i];
      if (region === item.code) {
        setRegion(item.code);
        this.region = region;
        return true;
      }
    }
    setRegion('cn-beijing-6');
    console.log(region, 222);
    this.region = getRegion();
  },
  components: {
    Breadcrumb,
    BreadcrumbItem,
    Button,
    ButtonGroup
  }
};
</script>
<style lang="stylus"></style>
